import React from 'react'
import { Text } from 'react-native-paper'
import { TouchableOpacity, View } from 'react-native'
import { IconChevronRight } from '../../assets/icons'
import { dynamicSize } from '../../utils/hooks'
import { helpers } from '@linqpal/common-frontend'

const { composeStyle } = helpers

const shadow = {
  shadowColor: '#000',
  shadowOffset: {
    width: 0,
    height: 2,
  },
  shadowOpacity: 0.25,
  shadowRadius: 3.84,
  elevation: 5,
}

export default function LinkBox({
  style = {},
  icon,
  iconStyle = {},
  text,
  subText,
  subTextStyle = {},
  textStyle = {},
  onPress,
  rightArrowColor = '#FFF',
}) {
  return (
    <TouchableOpacity
      onPress={onPress}
      style={composeStyle(
        {
          borderRadius: 30,
          height: dynamicSize(64),
          minHeight: dynamicSize(50),
          flexDirection: 'row',
          marginTop: dynamicSize(20),
          alignItems: 'center',
          backgroundColor: 'white',
          paddingHorizontal: 15,
          ...shadow,
        },
        style,
      )}
    >
      {icon}
      <View
        style={{
          width: '70%',
          fontSize: dynamicSize(16),
          lineHeight: dynamicSize(18),
        }}
      >
        <Text
          style={composeStyle(
            {
              opacity: 0.9,
              marginLeft: dynamicSize(15),
            },
            textStyle,
          )}
        >
          {text}
        </Text>
        {subText && (
          <Text
            style={composeStyle(
              {
                marginLeft: dynamicSize(15),
                opacity: 0.8,
                fontSize: 13,
                fontWeight: '300',
                marginTop: 2,
              },
              subTextStyle,
            )}
          >
            {subText}
          </Text>
        )}
      </View>
      <IconChevronRight
        style={{ marginLeft: 'auto' }}
        stroke={rightArrowColor}
      />
    </TouchableOpacity>
  )
}
